import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/v4ward/car/carMonthLog/page/v2', Object.assign({}, options, {
    params
  }));

export const getDetail = (params, options) =>
  request.get('/api/v4ward/car/carMonthLog/detail/v2', Object.assign({}, options, {
    params
  }));

export const remove = (params, options) =>
  request.post('/api/v4ward/car/carMonthLog/remove/v2', qs.stringify(params), options);

export const add = (params, options) =>
  request.post('/api/v4ward/car/carMonthLog/submit/v2', params, options);

export const update = (params, options) =>
  request.post('/api/v4ward/car/carMonthLog/submit/v2', params, options);
